import {
    CART_REQUEST,
    CART_SUCCESS,
    CART_FAIL,
    CART_ADD_ITEM_REQUEST,
    CART_ADD_ITEM_SUCCESS,
    CART_ADD_ITEM_FAIL,
    CART_UPDATE_ITEM_REQUEST,
    CART_UPDATE_ITEM_SUCCESS,
    CART_UPDATE_ITEM_FAIL,
    CART_REMOVE_ITEM_REQUEST,
    CART_REMOVE_ITEM_SUCCESS,
    CART_REMOVE_ITEM_FAIL,
    CART_CLEAR_REQUEST,
    CART_CLEAR_SUCCESS,
    CART_CLEAR_FAIL,
    CART_CLEAR_ITEMS,
  } from '../constants/cartConstants';
  
  // Retrieve cart items from local storage if available (for guests)
  const cartItemsFromStorage = localStorage.getItem('cartItems')
    ? JSON.parse(localStorage.getItem('cartItems'))
    : [];
  
  const initialState = {
    cartItems: cartItemsFromStorage,
    cartData: null,
    loading: false,
    error: null,
    success: false,
    addLoading: false,
    updateLoading: false,
    removeLoading: false,
    clearLoading: false
  };
  
  export const cartReducer = (state = initialState, action) => {
    switch (action.type) {
      case CART_REQUEST:
        return {
          ...state,
          loading: true,
          error: null
        };
      
      case CART_SUCCESS:
        return {
          ...state,
          loading: false,
          cartItems: action.payload.items,
          cartData: action.payload.cart,
          error: null
        };
      
      case CART_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload
        };
      
      case CART_ADD_ITEM_REQUEST:
        return {
          ...state,
          addLoading: true,
          error: null
        };
      
      case CART_ADD_ITEM_SUCCESS:
        // For authenticated users, the API will return the updated cart
        // For guests, we need to update the local storage
        const newItem = action.payload.item;
        const existItem = state.cartItems.find(x => x.product_id === newItem.product_id);
        
        let updatedCartItems;
        
        if (existItem) {
          updatedCartItems = state.cartItems.map(item =>
            item.product_id === existItem.product_id ? newItem : item
          );
        } else {
          updatedCartItems = [...state.cartItems, newItem];
        }
        
        // Save to local storage for guests
        if (!action.payload.isAuthenticated) {
          localStorage.setItem('cartItems', JSON.stringify(updatedCartItems));
        }
        
        return {
          ...state,
          addLoading: false,
          cartItems: updatedCartItems,
          success: true
        };
      
      case CART_ADD_ITEM_FAIL:
        return {
          ...state,
          addLoading: false,
          error: action.payload
        };
      
      case CART_UPDATE_ITEM_REQUEST:
        return {
          ...state,
          updateLoading: true,
          error: null
        };
      
      case CART_UPDATE_ITEM_SUCCESS:
        const updatedItem = action.payload.item;
        
        // Update cart items
        const updatedItems = state.cartItems.map(item =>
          item.id === updatedItem.id ? updatedItem : item
        );
        
        // Save to local storage for guests
        if (!action.payload.isAuthenticated) {
          localStorage.setItem('cartItems', JSON.stringify(updatedItems));
        }
        
        return {
          ...state,
          updateLoading: false,
          cartItems: updatedItems,
          success: true
        };
      
      case CART_UPDATE_ITEM_FAIL:
        return {
          ...state,
          updateLoading: false,
          error: action.payload
        };
      
      case CART_REMOVE_ITEM_REQUEST:
        return {
          ...state,
          removeLoading: true,
          error: null
        };
      
      case CART_REMOVE_ITEM_SUCCESS:
        const itemId = action.payload.itemId;
        
        // Filter out the removed item
        const filteredItems = state.cartItems.filter(item => 
          item.id !== itemId
        );
        
        // Save to local storage for guests
        if (!action.payload.isAuthenticated) {
          localStorage.setItem('cartItems', JSON.stringify(filteredItems));
        }
        
        return {
          ...state,
          removeLoading: false,
          cartItems: filteredItems,
          success: true
        };
      
      case CART_REMOVE_ITEM_FAIL:
        return {
          ...state,
          removeLoading: false,
          error: action.payload
        };
      
      case CART_CLEAR_REQUEST:
        return {
          ...state,
          clearLoading: true,
          error: null
        };
      
      case CART_CLEAR_SUCCESS:
      case CART_CLEAR_ITEMS:
        // Clear local storage for guests
        if (!action.payload?.isAuthenticated) {
          localStorage.removeItem('cartItems');
        }
        
        return {
          ...state,
          clearLoading: false,
          cartItems: [],
          success: true
        };
      
      case CART_CLEAR_FAIL:
        return {
          ...state,
          clearLoading: false,
          error: action.payload
        };
      
      default:
        return state;
    }
  };